<template>
  <PageWrap :page-title="pageTitle">
    <LoadingIndicator
      v-if="loadingData"
      class="mt-5"
    />

    <template v-else>
      <CommercialForm
        :data="formData"
        :editing="isEditing"
        :errors="formErrors"
        @update="updateForm"
        class="mb-5"
      />
      <BfButton
        v-if="!isEditing"
        @click="createCommercial"
      >
        Guardar
      </BfButton>

      <BfButton
        v-if="isEditing"
        variant="red"
        @click="showDeleteModal"
      >
        Eliminar
      </BfButton>

      <DeleteWarningModal
        v-model="displayDeleteModal"
        title="¿Desea eliminar este Comercial?"
        @confirm-deletion="deleteEntry"
      />
    </template>
  </PageWrap>
</template>

<script>
import CommercialForm from '@/components/FormGroups/CommercialForm';
import FormSectionHeader from '@/components/FormSectionHeader';
import LoadingIndicator from '@/components/LoadingIndicator';
import PageWrap from '@/components/PageWrap';
import DeleteWarningModal from '@/components/DeleteWarningModal';
import { commercialAPI } from '@/api';

export default {
  name: 'AssessorsDetail',

  props: {
    id: {
      type: String,
    },
  },

  data() {
    return {
      formData: {},
      formErrors: {},
      loadingData: false,
      displayDeleteModal: false,
    };
  },

  async created() {
    this.loadingData = true;

    try {
      if (this.isEditing) {
        console.log('modo editor');
        await this.loadData();
      } else {
        await this.prepareForm();
      }
    } finally {
      this.loadingData = false;
    }
  },

  methods: {
    async loadData() {
      const data = await commercialAPI.get(this.id);
      this.formData = data.data;
    },
    async prepareForm() {
      const { data } = await commercialAPI.preCreate();
      this.formData = data;
    },
    async updateForm({ key, value }) {
      const newData = { [key]: value };

      if (!this.isEditing) {
        this.formData = { ...this.formData, ...newData };
      } else {
        this.formErrors = {};

        try {
          const { data, message } = await commercialAPI.update({
            id: this.id,
            data: newData,
          });

          this.formData = data;
          this.$bfNotify({ title: 'Actualizado', message, type: 'success' });
        } catch ({ errors }) {
          this.formErrors = errors;
          this.$bfNotify({
            title: 'Error',
            message: 'Existe un error con tus datos',
            type: 'error',
          });
        }
      }
    },
    async createCommercial() {
      try {
        this.formErrors = {};
        const { data, message } = await commercialAPI.create(this.formData);

        this.$bfNotify({ title: 'Guardado', message, type: 'success' });
        this.$router.replace({ name: 'comercial', params: { id: `${data.id}` } });
      } catch ({ errors, message }) {
        this.formErrors = errors;
        this.$bfNotify({ title: 'Error', message: 'Existe un error con tus datos', type: 'error' });
      }
    },

    async showDeleteModal() {
      this.displayDeleteModal = true;
    },

    async deleteEntry() {
      try {
        const { message } = await commercialAPI.delete(this.id);

        this.$bfNotify({ title: 'Eliminado', message, type: 'success' });
        this.$router.replace({ name: 'comercial' });
      } catch ({ message }) {
        this.$bfNotify({ title: 'Error', message, type: 'error' });
      }
    },
  },

  computed: {
    isEditing() {
      return !!this.id;
    },

    pageTitle() {
      return this.isEditing ? `Comercial: ${this.formData.nombre || ''}` : 'Crear Comercial';
    },
  },

  components: {
    CommercialForm,
    DeleteWarningModal,
    FormSectionHeader,
    LoadingIndicator,
    PageWrap,
  },
};
</script>
